










import { Component, Prop, Vue } from 'vue-property-decorator';
import humanReadableQuantity from '@/filters/QuantityFormatter';
import { Quantity } from '@/model/Quantity';

@Component({
    filters: { humanReadableQuantity }
})
export default class ChangeQuantity extends Vue {

    @Prop({ default: false }) isQuantityDifferent: boolean;
    @Prop({ default: () => {} }) quantity: Quantity;
    @Prop({ default: null }) maxQuantity: number | null;

    addOne() {
        if(!this.quantity || this.quantity.value == null){
            return;
        }
        if (this.maxQuantity != null && this.quantity.value >= this.maxQuantity) {
            return;
        }
        this.quantity.value++;
        this.valueChanged();
    }

    removeOne() {
        if (!this.quantity || this.quantity.value == null || this.quantity.value < 1) {
            return;
        }
        this.quantity.value--;
        this.valueChanged();
    }

    valueChanged() {
        this.$emit("valueChange", this.quantity);
    }

}
